import {Suspense, useEffect} from "react";
import {Modal} from "react-bootstrap";

import {FormModalFooter} from "@/components/form/overlay/FormModalFooter.tsx";
import {Loader} from "@/components/placeholder/Loader.tsx";
import {AddedValue, CalculatedBillingData, Plan} from "@/lib/types/billing.ts";
import {Quote} from "@/pages/billing/checkout/components/Quote.tsx";

import "./QuotePrintable.css";

export interface QuoteModalProps {
  show: boolean;
  onClose: () => void;
  isCustomer: boolean;
  isUpgrade: boolean;
  isAnnual: boolean;
  plan?: Plan;
  addedValues: AddedValue[];
  calculatedData: CalculatedBillingData;
}

export const QuoteModal = ({
  show,
  onClose,
  isCustomer,
  isUpgrade,
  isAnnual,
  plan,
  addedValues,
  calculatedData,
}: QuoteModalProps) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add("modalprinter");
    }
    return () => {
      document.body.classList.remove("modalprinter");
    };
  }, [show]);
  return (
    <Modal onHide={onClose} show={show} centered backdrop={"static"} size="lg" className="px-lg-4 focused">
      <Modal.Body className="p-4">
        <Suspense fallback={<Loader text="Loading..." />}>
          <Quote
            isCustomer={isCustomer}
            isUpgrade={isUpgrade}
            isAnnual={isAnnual}
            plan={plan}
            addedValues={addedValues}
            calculatedData={calculatedData}
          />
        </Suspense>
      </Modal.Body>
      <FormModalFooter onCancel={onClose} hasSubmitButton={false} hasCancelButton={true} cancelText="Close" />
    </Modal>
  );
};
